<template>
  <div class="header d-flex flex-wrap p-2 p-md-4 px-md-5 align-content-center justify-content-between w-100">
    <div class="d-flex align-content-center mb-2 mb-md-0">
      <router-link class="mr-2" :to="{ name: 'TOEIC_list', params: { exam_type: exam_type } }">
        <img v-if="exam_type === 'toeic'" src="@/assets/image/toeic/toeic_exam/TOEIC.png" alt="" class="object-contain d-inline-block w-100">
        <img v-else src="@/assets/image/toeic/toeic_exam/TOEIC_bridge.png" alt="" class="object-contain d-inline-block w-100">
      </router-link>
      <div class="" v-if="isShowType">
        <img src="@/assets/image/toeic/toeic_exam/Speaking.png" alt="" class="object-contain d-inline-block" v-if="$route.params.practice_type === 'speaking'">
        <img src="@/assets/image/toeic/toeic_exam/Writing.png" alt="" class="object-contain d-inline-block" v-if="$route.params.practice_type === 'writing'">
      </div>
      <div class="" v-if="isShowText">
        <img src="@/assets/image/toeic/toeic_exam/exam_test_Speaking.png" alt="" class="object-contain d-inline-block">
      </div>
    </div>
    <div class="d-flex align-items-center"  v-if="$route.params.practice_type === 'writing'">
      <p v-if="$route.params.practice_type === 'writing'" class="px-3 py-1 d-flex align-items-center justify-content-center bg-white rounded pointer font-semibold text-blue-main-toeic text-xl d-inline-block mr-2 mb-0"><img src="@/assets/image/toeic/toeic_exam/show_time.png" alt="" class="mr-1">SHOW TIME |<span class="d-inline-block ml-1" :class="{ 'text-danger': (maxTime - answer_count) < 30 }">{{ formattedTime }}</span></p>
      <a v-if="$route.params.practice_type === 'writing'" class="px-3 py-1 d-flex align-items-center justify-content-center bg-blue-lighter2-toeic rounded pointer font-semibold text-blue-main-toeic text-xl d-inline-block"><img src="@/assets/image/toeic/toeic_exam/help.png" alt="" class="mr-1">Help</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'headerSection',

    data () {
      return {

      }
    },
    props: {
      exam_type: {
        type: String
      },
      isShowType: {
        type: Boolean,
        default: true
      },
      isShowText: {
        type: Boolean,
        default: false
      },
      maxTime: {
        type: Number,
        default: 60
      },
      answer_count: {
        type: Number,
        default: 0
      },
      formattedTime: {
        type: String
      }
      // practice_type: {
      //   type: String,
      //   default: 'writing'
      // }
    },

    components: {
    }
  }
</script>

<style lang="scss" scoped>
</style>
